import { render, staticRenderFns } from "./AjukanPenarikan.vue?vue&type=template&id=e18057e4&scoped=true&"
import script from "./AjukanPenarikan.vue?vue&type=script&lang=js&"
export * from "./AjukanPenarikan.vue?vue&type=script&lang=js&"
import style0 from "./AjukanPenarikan.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AjukanPenarikan.vue?vue&type=style&index=1&id=e18057e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18057e4",
  null
  
)

export default component.exports